import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllApplicantInfluencersForMarketplace.graphql';
import { Query, QueryallApplicantInfluencersForMarketplaceArgs } from '../../__generated__/globalTypes';

export const useAllApplicantInfluencersForMarketplaceQuery = (
  options?: QueryHookOptions<Query, QueryallApplicantInfluencersForMarketplaceArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallApplicantInfluencersForMarketplaceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllApplicantInfluencersForMarketplaceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallApplicantInfluencersForMarketplaceArgs>
): QueryResult<Query, QueryallApplicantInfluencersForMarketplaceArgs> & {
  getAllApplicantInfluencersForMarketplace: LazyQueryExecFunction<
    Query,
    QueryallApplicantInfluencersForMarketplaceArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllApplicantInfluencersForMarketplace, result] = useLazyQuery<
    Query,
    QueryallApplicantInfluencersForMarketplaceArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllApplicantInfluencersForMarketplace, ...result };
};

export const useAllApplicantInfluencersForMarketplacePromiseQuery = () => {
  const client = useApolloClient();

  const getAllApplicantInfluencersForMarketplace = useCallback(
    (options?: Omit<QueryOptions<QueryallApplicantInfluencersForMarketplaceArgs, Query>, 'query'>) =>
      client.query<Query, QueryallApplicantInfluencersForMarketplaceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllApplicantInfluencersForMarketplace };
};
// Suspense Query Hooks
export const useAllApplicantInfluencersForMarketplaceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallApplicantInfluencersForMarketplaceArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallApplicantInfluencersForMarketplaceArgs>(QUERY, {
    ...options
  });

  return result;
};
